import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import Footer from "../components/Footer";
import HeroPages from "../components/HeroPages";
import Logo from "../images/logo/logo.png";
import Vehicles from "../components/Vehicles";
import Services from "../components/Services";
import Rents from "../components/Rents";
import Truck from "../components/Truck";
import Taxi from "../components/Taxi";
import Payments from "../components/Payments";
import Damages from "../components/Damages";
import Upload from "../components/Upload";
import axios from 'axios';
import strings from '../components/strings.json';
import md5 from 'md5';

function Panel() {

  const navigate = useNavigate();
  const [nav, setNav] = useState(false);
  const [hovered, setHovered] = useState(false);
  const ut = sessionStorage.getItem('usertype');
  const [component, setComponent] = useState(<Vehicles lang={sessionStorage.getItem('lang')} />);
  const [page, setPage] = useState("Vehicles");

  const openNav = () => {
    setNav(!nav);
  };

  const Signout = async() => {
    if (sessionStorage.getItem('userdata') !== null) {
    try {
      await axios({
        method: "post",
        url: "https://api.hardrockrental.net/getSignout.php",
        data: {id: parseInt(sessionStorage.getItem('userdata_id')), un: sessionStorage.getItem('userdata')},
        headers: { "Content-Type": "multipart/Rents-data" },
      });
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('process');
        sessionStorage.removeItem('userdata_id');
        sessionStorage.removeItem('userstatus');
        sessionStorage.removeItem('userdata');
        sessionStorage.removeItem('usertype');
        sessionStorage.removeItem('nearex');
        sessionStorage.removeItem('nearex2');
        navigate('/');
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }
  }

  useEffect(() => {
    setTimeout(() => {
      if (sessionStorage.getItem('token') !== md5(sessionStorage.getItem('process'))) {
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('process');
      sessionStorage.removeItem('userdata_id');
      sessionStorage.removeItem('userstatus');
      sessionStorage.removeItem('userdata');
      navigate('/', { replace: true });
    }
    }, 1000);
  }, [sessionStorage, navigate])

  const openRents = () => {
    setComponent(<Rents lang={sessionStorage.getItem('lang')} />);
    setPage("Rents");
    setNav(!nav);
  }

  const openTruck = () => {
    setComponent(<Truck lang={sessionStorage.getItem('lang')} />);
    setPage("Truck");
    setNav(!nav);
  }

  const openTaxi = () => {
    setComponent(<Taxi lang={sessionStorage.getItem('lang')} />);
    setPage("Taxi");
    setNav(!nav);
  }

  const openPayments = () => {
    setComponent(<Payments lang={sessionStorage.getItem('lang')} />);
    setPage("Payments");
    setNav(!nav);
  }

  const openServices = () => {
    setComponent(<Services lang={sessionStorage.getItem('lang')} />);
    setPage("Services");
    setNav(!nav);
  }

  const openVehicles = () => {
    setComponent(<Vehicles lang={sessionStorage.getItem('lang')} />);
    setPage("Vehicles");
    setNav(!nav);
  }

  const openUpload = () => {
    setComponent(<Upload lang={sessionStorage.getItem('lang')} />);
    setPage("Upload");
    setNav(!nav);
  }

  const openDamages = () => {
    setComponent(<Damages lang={sessionStorage.getItem('lang')} />);
    setPage("Damages");
    setNav(!nav);
  }

  const openRents1 = () => {
    setComponent(<Rents lang={sessionStorage.getItem('lang')} />);
    setPage("Rents");
  }

  const openTruck1 = () => {
    setComponent(<Truck lang={sessionStorage.getItem('lang')} />);
    setPage("Truck");
  }

  const openTaxi1 = () => {
    setComponent(<Taxi lang={sessionStorage.getItem('lang')} />);
    setPage("Taxi");
  }

  const openPayments1 = () => {
    setComponent(<Payments lang={sessionStorage.getItem('lang')} />);
    setPage("Payments");
  }

  const openServices1 = () => {
    setComponent(<Services lang={sessionStorage.getItem('lang')} />);
    setPage("Services");
  }

  const openVehicles1 = () => {
    setComponent(<Vehicles lang={sessionStorage.getItem('lang')} />);
    setPage("Vehicles");
  }

  const openUpload1 = () => {
    setComponent(<Upload lang={sessionStorage.getItem('lang')} />);
    setPage("Upload");
  }

  const openDamages1 = () => {
    setComponent(<Damages lang={sessionStorage.getItem('lang')} />);
    setPage("Damages");
  }

  return (
    <>
    <nav>
        {/* mobile */}
        <div className={`mobile-navbar ${nav ? "open-nav" : ""}`}>
          <div onClick={openNav} className="mobile-navbar__close">
            <i className="fa-solid fa-xmark"></i>
          </div>
          {ut === md5("admin") ?
          <ul className="mobile-navbar__links">
            <li>
            {sessionStorage.getItem('nearex') > 0 ?
            <div 
            className="circle"
            onMouseEnter={() => setHovered(true)} 
            onMouseLeave={() => setHovered(false)}>
            {sessionStorage.getItem('nearex')}
            {hovered && <div className="hover-text">{sessionStorage.getItem('nearex2')}</div>}</div> : ""}
              <Link onClick={openVehicles}>
              {strings[sessionStorage.getItem('lang')].Panel1}
              </Link>
            </li>
            <li>
              <Link onClick={openRents}>
              {strings[sessionStorage.getItem('lang')].Panel7}
              </Link>
            </li>
            <li>
              <Link onClick={openTruck}>
              {strings[sessionStorage.getItem('lang')].Panel8}
              </Link>
            </li>
            <li>
              <Link onClick={openTaxi}>
              {strings[sessionStorage.getItem('lang')].Panel9}
              </Link>
            </li>
            <li>
              <Link onClick={openDamages}>
              {strings[sessionStorage.getItem('lang')].Panel3}
              </Link>
            </li>
            <li>
              <Link onClick={openPayments}>
              {strings[sessionStorage.getItem('lang')].Panel10}
              </Link>
            </li>
            <li>
              <Link onClick={openServices}>
              {strings[sessionStorage.getItem('lang')].Panel2}
              </Link>
            </li>
            <li>
              <Link onClick={openUpload}>
              {strings[sessionStorage.getItem('lang')].Panel4}
              </Link>
            </li>
            <li>
              <Link onClick={() => Signout()}>
              <i className="fa-solid fa-right-from-bracket"></i> &nbsp;{strings[sessionStorage.getItem('lang')].Panel5}
              </Link>
            </li>
          </ul>
          :
          <ul className="mobile-navbar__links">
            <li>
            {sessionStorage.getItem('nearex') > 0 ?
            <div 
            className="circle"
            onMouseEnter={() => setHovered(true)} 
            onMouseLeave={() => setHovered(false)}>
            {sessionStorage.getItem('nearex')}
            {hovered && <div className="hover-text">{sessionStorage.getItem('nearex2')}</div>}</div> : ""}
              <Link onClick={openVehicles}>
              {strings[sessionStorage.getItem('lang')].Panel1}
              </Link>
            </li>
            <li>
              <Link onClick={openRents}>
              {strings[sessionStorage.getItem('lang')].Panel7}
              </Link>
            </li>
            <li>
              <Link onClick={openTruck}>
              {strings[sessionStorage.getItem('lang')].Panel8}
              </Link>
            </li>
            <li>
              <Link onClick={openTaxi}>
              {strings[sessionStorage.getItem('lang')].Panel9}
              </Link>
            </li>
            <li>
              <Link onClick={openDamages}>
              {strings[sessionStorage.getItem('lang')].Panel3}
              </Link>
            </li>
            <li>
              <Link onClick={openPayments}>
              {strings[sessionStorage.getItem('lang')].Panel10}
              </Link>
            </li>
            <li>
              <Link onClick={() => Signout()}>
              <i className="fa-solid fa-right-from-bracket"></i> &nbsp;{strings[sessionStorage.getItem('lang')].Panel5}
              </Link>
            </li>
          </ul>
          }
        </div>

        {/* desktop */}

        <div className="navbar">
          <div className="navbar__img">
            <Link to="/" onClick={() => window.scrollTo(0, 0)}>
              <img src={Logo} alt="logo-img" />
            </Link>
          </div>
          {ut === md5("admin") ?
          <ul className="navbar__links">
            {sessionStorage.getItem('nearex') > 0 ?
            <div 
            className="circle"
            onMouseEnter={() => setHovered(true)} 
            onMouseLeave={() => setHovered(false)}>
            {sessionStorage.getItem('nearex')}
            {hovered && <div className="hover-text">{sessionStorage.getItem('nearex2')}</div>}</div> : ""}
            <li>
              <Link className="home-link" onClick={openVehicles1}>
              {strings[sessionStorage.getItem('lang')].Panel1}
              </Link>
            </li>
            <li>
              <Link onClick={openRents1}>
              {strings[sessionStorage.getItem('lang')].Panel7}
              </Link>
            </li>
            <li>
              <Link onClick={openTruck1}>
              {strings[sessionStorage.getItem('lang')].Panel8}
              </Link>
            </li>
            <li>
              <Link onClick={openTaxi1}>
              {strings[sessionStorage.getItem('lang')].Panel9}
              </Link>
            </li>
            <li>
              <Link className="about-link" onClick={openDamages1}>
              {strings[sessionStorage.getItem('lang')].Panel3}
              </Link>
            </li>
            <li>
              <Link className="about-link" onClick={openPayments1}>
              {strings[sessionStorage.getItem('lang')].Panel10}
              </Link>
            </li>
            <li>
              <Link className="about-link" onClick={openServices1}>
              {strings[sessionStorage.getItem('lang')].Panel2}
              </Link>
            </li>
            <li>
              <Link className="models-link" onClick={openUpload1}>
              {strings[sessionStorage.getItem('lang')].Panel4}
              </Link>
            </li>
          </ul>
          :
          <ul className="navbar__links">
            {sessionStorage.getItem('nearex') > 0 ?
            <div 
            className="circle"
            onMouseEnter={() => setHovered(true)} 
            onMouseLeave={() => setHovered(false)}>
            {sessionStorage.getItem('nearex')}
            {hovered && <div className="hover-text">{sessionStorage.getItem('nearex2')}</div>}</div> : ""}
          <li>
            <Link className="home-link" onClick={openVehicles1}>
              {strings[sessionStorage.getItem('lang')].Panel1}
            </Link>
          </li>
          <li>
              <Link onClick={openRents1}>
              {strings[sessionStorage.getItem('lang')].Panel7}
              </Link>
            </li>
            <li>
              <Link onClick={openTruck1}>
              {strings[sessionStorage.getItem('lang')].Panel8}
              </Link>
            </li>
            <li>
              <Link onClick={openTaxi1}>
              {strings[sessionStorage.getItem('lang')].Panel9}
              </Link>
            </li>
            <li>
            <Link className="about-link" onClick={openDamages1}>
            {strings[sessionStorage.getItem('lang')].Panel3}
            </Link>
          </li>
          <li>
            <Link className="about-link" onClick={openPayments1}>
            {strings[sessionStorage.getItem('lang')].Panel10}
            </Link>
          </li>
        </ul>
          }
          <div className="navbar__buttons" onClick={() => Signout()}>
            <Link className="navbar__buttons__register">
            <i className="fa-solid fa-right-from-bracket"></i> &nbsp;{strings[sessionStorage.getItem('lang')].Panel5}
            </Link>
          </div>

          {/* mobile */}
          <div className="mobile-hamb" onClick={openNav}>
            <i className="fa-solid fa-bars"></i>
          </div>
        </div>
      </nav>
      <section className="contact-page">
        <HeroPages name={strings[sessionStorage.getItem('lang')].Panel6} name2={page} />
        <div className="cotnainer">
          {component}
        </div>
        <Footer lang={sessionStorage.getItem('lang')} />
      </section>
    </>
  );
}

export default Panel;
